import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

export class ExpiredMetadataCertificateModal extends Component {

  handleHideModalExpiredMetadataCertificate = () => {
    this.props.handleHideModalExpiredMetadataCertificate()
  }

  handleChooseOtherMetadata = () => {
    this.props.handleChooseOtherMetadata()
  }

  render() {
    return (
        <div className="action-block">
          <Modal
              show={this.props.modalExpiredMetadataCertificateIsShown}
              onHide={this.handleHideModalExpiredMetadataCertificate}
              container={this}
              dialogClassName="duplication-modal"
          >
            <Modal.Header
                className="duplication-modal-header"
            >
              <Modal.Title className="line-height-for-modal-title">
                <span className="exclamation-sign-rectangle"><span
                    className="exclamation-mark"/></span>
                <span className="expired-metadata-certificate-modal-header">Expired metadata certificate(s)</span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideModalExpiredMetadataCertificate}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="duplication-modal-body"
            >
              <div className="expired-metadata-certificate-modal-text">
                This metadata has one or more expired certificate(s).
                Import other metadata.
              </div>
            </Modal.Body>
            <Modal.Footer className="duplication-modal-footer">
              <button
                  type="button"
                  className="btn btn-link choose-other-metadata-button"
                  onClick={this.handleChooseOtherMetadata}
              >
                Choose different metadata
              </button>
            </Modal.Footer>
          </Modal>
        </div>
    );
  }

}